<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group label="Label"
                :error="getError('label')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.label"
                    required />
            </x-form-group>

            <x-form-group label="SMS Ulang Tahun"
                :error="getError('sms_birthday_blast')">
                <x-checkbox-wrapper label="Aktifkan SMS blast ulang tahun">
                    <input type="checkbox"
                        v-model="fields.sms_birthday_blast" />
                </x-checkbox-wrapper>
            </x-form-group>

            <x-form-group label="Trigger Masuk" :error="getError(`enter_trigger`)">
                <x-input-group-trigger 
                    :errorPrefix="`enter_trigger.`"
                    :errors="errors"
                    :initialFields="fields.enter_trigger"
                    @input="trigger => fields.enter_trigger = trigger" 
                />
            </x-form-group>

            <x-form-group label="Trigger Keluar" :error="getError(`exit_trigger`)">
                <x-input-group-trigger 
                    :errorPrefix="`exit_trigger.`"
                    :errors="errors"
                    :initialFields="fields.exit_trigger"
                    @input="trigger => fields.exit_trigger = trigger" 
                />
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XInputGroupTrigger from '../../components/XInputGroupTrigger.vue'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XFormGroup,
        XCheckboxWrapper,
        XInputGroupTrigger,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        }
    },
    data() {
        return {
            fields: {
                label: null,
                sms_birthday_blast: false,
                enter_trigger: { active: false },
                exit_trigger: { active: false },
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit', this.fields)
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
}
</script>